import React from 'react';
import { useSelector } from 'react-redux';
import { Message, MessageProps } from 'semantic-ui-react';
import ReactDOM from 'react-dom';

import { InsightsState } from 'app-redux/InsightsState';
import { InsightsReduxNotification } from 'app-redux/notification';

const Notification: React.FC = () => {
  const { message, notificationType } = useSelector<InsightsState, InsightsReduxNotification>(
    state => state.notification
  );

  if (!message) {
    return null;
  }

  const messageProps = {
    positive: notificationType === 'SUCCESS',
    negative: notificationType === 'ERROR',
    color: notificationType === 'NEUTRAL' ? 'blue' : undefined, // LINK: https://react.semantic-ui.com/collections/message/#variations-color
  } as MessageProps;

  return (
    <div className="bd-toast bd-animation-fade-in">
      <Message {...messageProps}>{message}</Message>
    </div>
  );
};

export default class extends React.Component {
  render() {
    return ReactDOM.createPortal(<Notification />, document.getElementById('notification'));
  }
}
